import React from "react";
import styled from "styled-components";
import { PrimaryButton, SecondaryButton } from "../common/Button";

const Section = styled.section`
  padding: clamp(4rem,6vw,5.5rem) 8vw;
  text-align: center;
  border-top: 1px solid var(--ink-06);
  background:
    radial-gradient(circle at 50% 0%, rgba(214,179,106,.08), transparent 40%);
`;

const Title = styled.h2`
  font-family: "DM Serif Display", serif;
  font-size: clamp(2rem,4vw,3.2rem);
  line-height: 1.05;
  margin-bottom: 14px;
  color: var(--ink);
`;

const Sub = styled.p`
  max-width: 36rem;
  margin: 0 auto 28px;
  color: var(--muted);
  line-height: 1.8;
`;

const Actions = styled.div`
  display: flex; gap: 14px; justify-content: center; flex-wrap: wrap;
  @media (max-width: 480px) { flex-direction: column; align-items: stretch; }
`;

const HomeCTA: React.FC = () => (
  <Section>
    <Title>Ready to start a project?</Title>
    <Sub>
      Whether you're an artist, manager, label, or brand — we'd like to hear
      what you're working on.
    </Sub>
    <Actions>
      <PrimaryButton to="/contact">Start an inquiry</PrimaryButton>
      <SecondaryButton to="/music">Browse catalog</SecondaryButton>
    </Actions>
  </Section>
);

export default HomeCTA;
